import { render } from "./ConnectSmartboxForm.vue?vue&type=template&id=2857aad8"
import script from "./ConnectSmartboxForm.vue?vue&type=script&lang=js"
export * from "./ConnectSmartboxForm.vue?vue&type=script&lang=js"
script.render = render

export default script